import { Eye, EyeOff } from 'lucide-react';

type PasswordFieldProps = {
  label: string;
  value: string;
  onChange: (v: string) => void;
  visible: boolean;
  onToggleVisible: () => void;
  minLength?: number;
  invalid?: boolean;
  errorText?: string;
  placeholder?: string;
};

export function PasswordField({
  label,
  value,
  onChange,
  visible,
  onToggleVisible,
  minLength,
  invalid,
  errorText,
  placeholder,
}: PasswordFieldProps) {
  return (
    <div>
      <label className="mb-1.5 block text-[11px] font-semibold tracking-wide text-[var(--dash-muted)] uppercase">
        {label}
      </label>
      <div className="relative">
        <input
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required
          placeholder={placeholder}
          minLength={minLength}
          className={`w-full rounded-xl border bg-[var(--dash-soft)] px-3.5 py-2.5 pr-10 text-sm outline-none focus:ring-2 ${
            invalid
              ? 'border-red-300 focus:border-red-400 focus:ring-red-200/30'
              : 'border-[var(--dash-line)] focus:border-[var(--dash-brand)] focus:ring-[var(--dash-brand)]/15'
          }`}
        />
        <button
          type="button"
          onClick={onToggleVisible}
          className="absolute top-1/2 right-3 -translate-y-1/2 text-[var(--dash-muted)]"
        >
          {!visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
      {errorText ? <p className="mt-1 mb-0 text-xs text-red-500">{errorText}</p> : null}
    </div>
  );
}
